import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;
export function requestLogError(data) {
  return fetch.post(`${BASE_URL}/api/app/uierror`, data);
}
